import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { DENY_PROPOSAL_URL } from './action-api-urls';
import { ActionProposal } from './action-types';

export interface DenyActionRequest {
  reason?: string;
}

export interface DenyActionResponse {
  success: boolean;
  message: string | null;
  data: ActionProposal | null;
}

export default async function deny_action_api_call(
  proposalId: string,
  denyData?: DenyActionRequest
): Promise<ActionProposal | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: DENY_PROPOSAL_URL(shopSlug, proposalId),
      method: 'POST',
      body: JSON.stringify(denyData || {}),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'DENY_ACTION_PROPOSAL';
    const customMsg = 'Action proposal denied successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: DenyActionResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during deny action proposal request');
    return null;
  }
}
